import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-events-block',
  styleUrl: 'feed.css',
  shadow: true,
})
export class EventsBlock {
  @Prop() viewmorehref: string = "#";
  @Prop() viewmoretext: string = "View More Events";
  @Prop() eventhead: string = "EVENTS";

  render() {
    return (
      <div class="paragraph-events">
        <div class="events-header">
          <div class="events-title">{this.eventhead}</div>
        </div>
        <slot />
        <div class="events-footer">
          <a class="button-block-blue" href={this.viewmorehref}>{this.viewmoretext}</a>
        </div>
      </div>
    );
  }
}
